import useSWR from "swr";
import qs from "qs";
import { useState } from "@wordpress/element";

import { Button } from "../../_form/button";
import { Input } from "../../_form/input";
import { ClearIcon } from "./components/clear-icon";
import { fetcher } from "../../fetcher";
import { Accordion } from "./components/accordion";
import { EmptyIcon } from "./components/empty-icon";

export function Block({
	text,
	editor = false,
	url,
	placeholder,
	currentLanguage,
}) {
	const [open, setOpen] = useState(false);
	const [searchQuery, setSearchQuery] = useState("");

	const params = qs.stringify(
		{ search: searchQuery, lang: currentLanguage },
		{ addQueryPrefix: true },
	);

	const { data, isLoading } = useSWR(
		`/wp-json/steam-api/positions${params}`,
		fetcher,
		{
			keepPreviousData: true,
		},
	);

	const content = data ?? [];

	const limited = open ? content : content.slice(0, 15);

	const grouped = limited.reduce((accumulator, position) => {
		const letter = position.title.charAt(0).toUpperCase();

		if (letter in accumulator) {
			accumulator[letter].push(position);
		} else {
			accumulator[letter] = [position];
		}

		return accumulator;
	}, {});

	const entries = Object.entries(grouped);
	const isEmpty = content.length === 0;
	const hasMore = content.length > 15;

	return (
		<>
			<div className="wp-block-steam-blocks-vacancies__left">
				<span className="has-fluid-2-font-size">
					{text({ label: "heading" })}
				</span>

				<div className="wp-block-steam-blocks-vacancies__form">
					<Input
						value={searchQuery}
						placeholder={placeholder}
						onChange={() => setSearchQuery(event.target.value)}
					/>

					<div className="wp-block-steam-blocks-vacancies__buttons">
						<Button variant="outline" onClick={() => setSearchQuery("")}>
							{text({ label: "button-clear" })}

							<ClearIcon width="14" stroke="currentColor" />
						</Button>

						<Button>{text({ label: "button-submit" })}</Button>
					</div>
				</div>
			</div>

			<div className="wp-block-steam-blocks-vacancies__right">
				{isEmpty && !isLoading && (
					<div className="wp-block-steam-blocks-vacancies__empty">
						<EmptyIcon />

						<span className="has-fluid-5-font-size">
							{text({ label: "empty" })}
						</span>
					</div>
				)}

				{entries.map(([letter, positions]) => (
					<div key={letter} className="wp-block-steam-blocks-vacancies__group">
						<span className="wp-block-steam-blocks-vacancies__letter">
							{letter}
						</span>

						<div className="wp-block-steam-blocks-vacancies__accordions">
							{positions.map((position) => (
								<Accordion key={position.id} position={position}>
									<div>
										<Button tag={editor ? "span" : "a"} href={url}>
											{text({ label: "button-apply" })}
										</Button>
									</div>
								</Accordion>
							))}
						</div>
					</div>
				))}

				{!isEmpty && !open && hasMore && (
					<div>
						<Button
							onClick={() => !editor && setOpen(true)}
							className="wp-block-steam-blocks-vacancies__show-more"
						>
							{text({ label: "button-show-more" })}
						</Button>
					</div>
				)}
			</div>
		</>
	);
}
